import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "min-w-0 w-full" }, [
    _c(
      "div",
      { staticClass: "controls-bar" },
      [
        _c(
          "div",
          { staticClass: "control-group control-group--cs" },
          [
            _c("common-select", {
              attrs: {
                label: "Año",
                "value-string": _vm.selectedYearString,
                "col-size": 12,
                items: _vm.years,
              },
              on: {
                "update:valueString": function ($event) {
                  _vm.selectedYearString = $event
                },
                "update:value-string": function ($event) {
                  _vm.selectedYearString = $event
                },
                change: _vm.fetchRegionalIndicators,
              },
              model: {
                value: _vm.selectedYear,
                callback: function ($$v) {
                  _vm.selectedYear = $$v
                },
                expression: "selectedYear",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "controls-sep" }),
        _c(
          "div",
          { staticClass: "control-group control-group--cs" },
          [
            _c("common-select", {
              attrs: {
                label: "Mes",
                "value-string": _vm.selectedMonthString,
                "col-size": 12,
                items: _vm.months,
              },
              on: {
                "update:valueString": function ($event) {
                  _vm.selectedMonthString = $event
                },
                "update:value-string": function ($event) {
                  _vm.selectedMonthString = $event
                },
                change: _vm.fetchRegionalIndicators,
              },
              model: {
                value: _vm.selectedMonth,
                callback: function ($$v) {
                  _vm.selectedMonth = $$v
                },
                expression: "selectedMonth",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "controls-sep" }),
        _c(
          "div",
          { staticClass: "control-group" },
          [
            _c(VSelect, {
              staticClass: "filter-select",
              attrs: {
                label: "Región",
                items: _vm.regions,
                "item-text": "name",
                "item-value": "name",
                dense: "",
                outlined: "",
                "hide-details": "",
              },
              on: { change: _vm.fetchRegionalIndicators },
              model: {
                value: _vm.selectedRegion,
                callback: function ($$v) {
                  _vm.selectedRegion = $$v
                },
                expression: "selectedRegion",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "controls-sep" }),
        _c(
          VBtn,
          {
            staticClass: "btn-inca-secondary",
            attrs: { small: "", outlined: "" },
            on: { click: _vm.downloadCsv },
          },
          [
            _c(VIcon, { attrs: { small: "", left: "" } }, [
              _vm._v("mdi-download"),
            ]),
            _vm._v(" Descargar CSV "),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "regional-content" },
      [
        _c("div", { staticClass: "region-header" }, [
          _c("div", { staticClass: "region-title" }, [
            _vm._v("Indicadores Regionales – " + _vm._s(_vm.selectedRegion)),
          ]),
          _c("span", { staticClass: "period-badge" }, [
            _vm._v(_vm._s(_vm.periodLabel)),
          ]),
        ]),
        _c(
          VTabs,
          {
            staticClass: "regional-tabs",
            attrs: { color: "#1a2fbe", "slider-color": "#1a2fbe" },
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          [
            _c(VTab, [_vm._v("Indicadores Regionales 1")]),
            _c(VTab, [_vm._v("Indicadores Regionales 2")]),
          ],
          1
        ),
        _c(
          VTabsItems,
          {
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          [
            _c(VTabItem, [
              _c(
                "div",
                { staticClass: "indicators-grid" },
                [
                  _c("somos1-v2-indicador-tipo1-card", {
                    attrs: {
                      title: "Ventas",
                      items: _vm.ingresosItems,
                      "total-item": _vm.ingresosTotal,
                    },
                  }),
                  _c("somos1-v2-indicador-tipo1-card", {
                    attrs: {
                      title: "EBITDA YTD",
                      items: _vm.ebitdaItems,
                      "total-item": _vm.ebitdaTotal,
                    },
                  }),
                  _c("somos1-v2-indicador-tipo1-card", {
                    attrs: {
                      title: "Colocaciones",
                      subtitle: "SALDO S/ MILLONES",
                      items: _vm.colocacionesItems,
                      "total-item": _vm.colocacionesTotal,
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(VTabItem, [
              _c(
                "div",
                { staticClass: "indicators-grid-2" },
                [
                  _c("somos1-v2-indicador-tipo2-card", {
                    attrs: {
                      title: "Locales (#)",
                      type: "count",
                      items: _vm.localesItems,
                      "total-item": _vm.localesTotal,
                    },
                  }),
                  _c("somos1-v2-indicador-tipo2-card", {
                    attrs: {
                      title: "Colaboradores (#)",
                      type: "count",
                      items: _vm.colaboradoresItems,
                      "total-item": _vm.colaboradoresTotal,
                    },
                  }),
                  _c("somos1-v2-indicador-tipo2-card", {
                    attrs: {
                      title: "NPS",
                      type: "percent",
                      items: _vm.npsItems,
                      "total-item": _vm.npsTotal,
                    },
                  }),
                  _c("somos1-v2-indicador-tipo2-card", {
                    attrs: {
                      title: "Clima Laboral",
                      type: "percent",
                      items: _vm.climaItems,
                      "total-item": _vm.climaTotal,
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }